import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { optimizeProductImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import brandPage from "@faire/web-api--source/routes/brand/brandToken";
import React, { Suspense } from "react";
import styled from "styled-components";
import { AspectRatioPicture } from "@faire/retailer/components/Image/AspectRatioPicture";
import { Image } from "@faire/retailer/components/Image/Image";
import { LazySamplesRequestModal } from "@faire/retailer/components/Modals/SamplesRequestModal/LazySamplesRequestModal";
import { SamplesRequestStoreProvider } from "@faire/retailer/components/Modals/SamplesRequestModal/SamplesRequestStore";
var IMAGE_WIDTH = 220;
export var SampleBrandTile = function(param) {
    var simpleBrandTile = param.simpleBrandTile, sourcePage = param.sourcePage, onClick = param.onClick;
    var _React_useState = _sliced_to_array(React.useState(false), 2), showSamplesModal = _React_useState[0], setShowSamplesModal = _React_useState[1];
    var isSSR = useIsSSR();
    var _simpleBrandTile_token, _simpleBrandTile_profile_image_proto;
    return /*#__PURE__*/ _jsxs(StyledColumn, {
        children: [
            /*#__PURE__*/ _jsxs(StyledLink, {
                onClick: function() {
                    var _simpleBrandTile_token;
                    onClick === null || onClick === void 0 ? void 0 : onClick((_simpleBrandTile_token = simpleBrandTile.token) !== null && _simpleBrandTile_token !== void 0 ? _simpleBrandTile_token : "");
                },
                "data-test-id": "sample-brand-tile",
                to: brandPage((_simpleBrandTile_token = simpleBrandTile.token) !== null && _simpleBrandTile_token !== void 0 ? _simpleBrandTile_token : ""),
                children: [
                    /*#__PURE__*/ _jsx(AspectRatioPicture, {
                        $ratio: 1,
                        $width: "100%",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: optimizeProductImageUrl((_simpleBrandTile_profile_image_proto = simpleBrandTile.profile_image_proto) !== null && _simpleBrandTile_profile_image_proto !== void 0 ? _simpleBrandTile_profile_image_proto : IImage.build({}), isSSR, IMAGE_WIDTH)
                        })
                    }),
                    /*#__PURE__*/ _jsx(BrandNameWrapper, {
                        children: /*#__PURE__*/ _jsx(Typography, {
                            truncate: true,
                            variant: "paragraphSansMedium",
                            children: simpleBrandTile.name
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(StyledButton, {
                variant: "secondary",
                onClick: function() {
                    return setShowSamplesModal(true);
                },
                children: simpleBrandTile.cta_text
            }),
            showSamplesModal && simpleBrandTile.token ? /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(SamplesRequestStoreProvider, {
                    children: /*#__PURE__*/ _jsx(LazySamplesRequestModal, {
                        brandToken: simpleBrandTile.token,
                        source: sourcePage !== null && sourcePage !== void 0 ? sourcePage : "HOME",
                        onClose: function() {
                            return setShowSamplesModal(false);
                        }
                    })
                })
            }) : null
        ]
    });
};
var BrandNameWrapper = styled.div.withConfig({
    componentId: "sc-f4cd1923-0"
})([
    "text-align:center;padding:",
    ";width:100%;"
], getSpacing("2x"));
var StyledColumn = styled(Column).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-f4cd1923-1"
})([
    "background:",
    ";"
], Core.surface.inverse);
var StyledButton = styled(Button).withConfig({
    componentId: "sc-f4cd1923-2"
})([
    "width:80%;margin-bottom:",
    ";"
], getSpacing("2x"));
var StyledLink = styled(Link).withConfig({
    componentId: "sc-f4cd1923-3"
})([
    "display:contents;"
]);
